import React from 'react';
import { cn } from '@/utils/cn';
import TextSmall from '../Typography/TextSmall';
import TextSpan from '../Typography/TextSpan';
import TextBase from '../Typography/TextBase';

function ProductFilterColor({
  colors,
  setColors,
  onSelectedColor,
  selectedColors = [],
}) {
  const handleActiveColor = (itemSelected) => {
    const selectedColorsTemp = selectedColors?.length
      ? JSON.parse(JSON.stringify([...selectedColors]))
      : [];
    // creating a copy of the store obj
    const selectedItemsTemp = [...colors];
    const newFilter = selectedItemsTemp.map((item, _) => ({
      ...item,
      data: item?.data?.map((subItem) =>
        subItem.key === itemSelected.key &&
        subItem.id === itemSelected.id &&
        subItem.nameEn === itemSelected.nameEn
          ? { ...subItem, isChecked: !subItem.isChecked }
          : subItem,
      ),
    }));

    setColors([...newFilter]);
    if (!selectedColorsTemp.includes(itemSelected?.name?.en)) {
      if (onSelectedColor) {
        onSelectedColor([...selectedColorsTemp, itemSelected.name?.en]);
      }
    } else if (onSelectedColor) {
      onSelectedColor(
        selectedColorsTemp.filter((_item) => _item !== itemSelected.name?.en),
      );
    }
  };

  return (
    <div className="product-filter-colors">
      {colors?.length && colors[0]?.name?.en ? (
        <div className="mb-20 sm:mb-24">
          <TextBase className="font-semibold mb-8">
            {colors?.length && colors[0]?.name?.en ? colors[0]?.name?.en : null}{' '}
            ({colors?.length && colors[0]?.count})
          </TextBase>

          <div className="flex items-center flex-wrap gap-1 mb-8">
            {colors?.length
              ? colors[0]?.data?.map((item) => (
                  <div
                    role="presentation"
                    key={item?.id}
                    className={cn(
                      'border-2 border-transparent rounded-full cursor-pointer',
                      {
                        '!border-richcarmine shadow-compare-bottom-action':
                          item.isChecked,
                      },
                    )}
                    onClick={() => handleActiveColor(item)}
                  >
                    <div
                      className="size-[31px] lg:size-[36px] rounded-full"
                      style={{ backgroundColor: item?.color_code }}
                    />
                  </div>
                ))
              : null}
          </div>

          <TextSmall className="text-senate font-medium w-full flex flex-wrap items-center">
            {`Selected: `}&nbsp;
            {selectedColors?.length ? (
              selectedColors?.map((item, index) => (
                <TextSpan
                  key={`${item}-${index}`}
                  className="text-sm lg:text-base inline-block text-richcarmine font-semibold capitalize mr-[4px]"
                >
                  {item || 'None'}
                  {selectedColors.length > 1 &&
                    index < selectedColors.length - 1 &&
                    ', '}
                </TextSpan>
              ))
            ) : (
              <TextSpan
                text="None"
                className="text-sm lg:text-base inline-block font-semibold capitalize tracking-[0.32px]"
              />
            )}
          </TextSmall>

          <div className="my-[16px] border-b border-aquarelle-purple" />
        </div>
      ) : null}
    </div>
  );
}

export default ProductFilterColor;
